import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import classNames from 'classnames'

class Checkbox extends Component {
  render () {
    return (
      <div className={classNames('relative', this.props.className)}>
        <input
          type="checkbox"
          id={this.props.id}
          name={this.props.name}
          value={this.props.value}
          required={this.props.required}
          checked={this.props.checked}
          onChange={this.props.onChange}
          className="absolute top-0 left-0 opacity-0 w-full h-full z-20 cursor-pointer"
        />

        <span className="w-8 h-8 flex items-center justify-center border-coral border z-10">
          <span className={classNames('w-4 h-4 block', { 'opacity-100': this.props.checked }, { 'opacity-0': !this.props.checked })} aria-hidden="true">
            <Sprite name="tick" />
          </span>
        </span>
      </div>
    )
  }
}

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string
}

export default Checkbox
